import styled from '@emotion/styled';

import variables from 'theme/styles/vars';
export default styled.div`
padding: 20em 0;
text-align:center;
background-color:#F3F3F3;
.headline {
    font-size: 2em;
    font-weight: 700;
    margin-bottom: 1.2em;
}

.txt {
    margin-bottom: 2.5em;
}

.txt-small {
    margin-bottom: 1em;
}

.link {
    color: inherit;
}
.layout-button  {
    margin-bottom: 2.5em;
}

`;